export default function ECATStatementDocumentController(
  $q,
  $rootScope,
  $scope,
  alerts,
  ecatDataService,
  ecatSharedModelService,
  confirmDialog,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  editStatementDocumentDialog,
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No CRI Statement Document Added';
  vm.isExpanded = false;
  vm.canDeleteItem = vm.canDelete;
  vm.canDeleteItem = true;
  vm.canEditItem = vm.canEdit;

  // Attach Event Handlers
  vm.handleEditStatementDocument = _handleEditStatementDocument;
  vm.handleUnattachStatementDocument = _handleUnattachStatementDocument;

  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  function _handleEditStatementDocument($event) {
    ssDialogService.dialogs.ecat.editStatementDocumentDialog = ssDialogService.alert(
      editStatementDocumentDialog.getOptions($event, {
        criStatementId: vm.criStatementId,
        document: vm.statementDocument,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.ecat.editStatementDocumentDialog);
  }

  function _handleUnattachStatementDocument($event) {
    ssDialogService.dialogs.ecat.deleteCRIStatementDocumentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Remove CRI Statement Document?',
        message: `Are you sure you want to remove document "${vm.statementDocument.description}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.ecat.deleteCRIStatementDocumentConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return ecatDataService.detachCRIStatementDocument(vm.statementDocument.CRIStatementDocumentId)
      .then(() => {
        alerts.success('The document has been removed successfully.');
        $rootScope.$broadcast('refreshCRIStatementDocuments', { criStatementId: vm.criStatementId });
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('An error occurred while removing the document.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.ecat.deleteCRIStatementDocumentConfirmDialog);
  }
}

ECATStatementDocumentController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'ecatDataService',
  'ecatSharedModelService',
  'confirmDialog',
  'docDataService',
  'loaderService',
  'orgDataService',
  'ssDialogService',
  'editStatementDocumentDialog'
];
